<template>
  <div :id="echartParam.id" style="width:1400px;height:400px;"></div>
</template>

<script>
import Vue from 'vue';
import echarts from 'echarts';
import { Script } from 'vm';

Vue.prototype.$echarts = echarts;
export default {
  name: 'RealEcharts',
  props: ['echartParam'],
  data() {
    return {
      id: this.echartParam.id,
      myChart: undefined,
      myChartData: [],
      chartstimescope: 1,
      lastcharttime: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(this.id));
    },
    myChartSetOption(option) {
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
    myChartClear() {
      this.myChart.clear();
    }

  }
};
</script>
<style>
</style>
